/**
 * Auto-generated MDI icon registry — do not edit manually.
 * Re-generate: node scripts/generateMdiIcons.js
 */

import { h, defineComponent } from "vue";
import { VSvgIcon } from "vuetify/lib/composables/icons.js";
import {
  mdiAccount,
  mdiGit,

  mdiAccountBox,
  mdiAccountCancel,
  mdiAccountCash,
  mdiAccountCheck,
  mdiAccountClock,
  mdiAccountCog,
  mdiAccountEdit,
  mdiAccountGroup,
  mdiAccountMultiple,
  mdiAccountOff,
  mdiAccountPlus,
  mdiAccountRemove,
  mdiAccountTie,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOctagon,
  mdiAlertOutline,
  mdiApi,
  mdiApps,
  mdiAppsBox,
  mdiArchive,
  mdiArrowCollapseVertical,
  mdiArrowDown,
  mdiArrowExpandVertical,
  mdiArrowLeft,
  mdiArrowUp,
  mdiBank,
  mdiBookEditOutline,
  mdiBookOpenPageVariant,
  mdiBookOpenVariant,
  mdiBriefcase,
  mdiBriefcaseCheck,
  mdiBriefcaseOff,
  mdiBriefcaseOutline,
  mdiBriefcasePlus,
  mdiBriefcaseRemove,
  mdiBriefcaseSearch,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiCalculator,
  mdiCalculatorVariant,
  mdiCalendar,
  mdiCalendarAccount,
  mdiCalendarBlank,
  mdiCalendarBlankOutline,
  mdiCalendarCheck,
  mdiCalendarCheckOutline,
  mdiCalendarClock,
  mdiCalendarMinus,
  mdiCalendarMonth,
  mdiCalendarPlus,
  mdiCalendarRange,
  mdiCalendarRemove,
  mdiCalendarToday,
  mdiCalendarWeek,
  mdiCamera,
  mdiCancel,
  mdiCash,
  mdiCashMultiple,
  mdiCashRegister,
  mdiCellphoneKey,
  mdiChartAreaspline,
  mdiChartBar,
  mdiChartBoxMultipleOutline,
  mdiChartBoxOutline,
  mdiChartLine,
  mdiChartLineVariant,
  mdiChartTimeline,
  mdiCheck,
  mdiCheckAll,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckboxMultipleBlankOutline,
  mdiCheckboxMultipleMarked,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiCircleHalfFull,
  mdiCircleOutline,
  mdiCity,
  mdiCityVariant,
  mdiClipboardAlertOutline,
  mdiClipboardCheckOutline,
  mdiClipboardList,
  mdiClipboardTextOutline,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCloudDownload,
  mdiCloudOutline,
  mdiCodeBraces,
  mdiCog,
  mdiCogOff,
  mdiCogOutline,
  mdiCommentEdit,
  mdiCommentPlus,
  mdiCommentRemove,
  mdiCommentTextMultiple,
  mdiConsole,
  mdiContentCopy,
  mdiContentDuplicate,
  mdiContentSave,
  mdiCounter,
  mdiCurrencyUsd,
  mdiDatabase,
  mdiDatabaseEditOutline,
  mdiDatabaseImport,
  mdiDatabasePlus,
  mdiDatabaseRemove,
  mdiDelete,
  mdiDeleteAlert,
  mdiDeleteSweep,
  mdiDotsVertical,
  mdiDownload,
  mdiDownloadOff,
  mdiDownloadOutline,
  mdiEarth,
  mdiEarthOff,
  mdiEmailCheck,
  mdiEmailFast,
  mdiEmailLock,
  mdiEmailOutline,
  mdiEmailSync,
  mdiEqual,
  mdiExport,
  mdiEye,
  mdiEyeCheck,
  mdiEyeOff,
  mdiFile,
  mdiFileDelimited,
  mdiFileDelimitedOutline,
  mdiFileDocument,
  mdiFileDocumentMultiple,
  mdiFileDocumentOutline,
  mdiFileExcel,
  mdiFileExcelBox,
  mdiFileExcelOutline,
  mdiFileImportOutline,
  mdiFilePdfBox,
  mdiFileTree,
  mdiFileUpload,
  mdiFileWord,
  mdiFilter,
  mdiFilterOff,
  mdiFilterRemove,
  mdiFilterVariant,
  mdiFlag,
  mdiFolderImage,
  mdiFolderMultiple,
  mdiFolderMultipleImage,
  mdiFolderOpenOutline,
  mdiFolderZip,
  mdiFoodApple,
  mdiFoodVariant,
  mdiFormSelect,
  mdiFormatListBulleted,
  mdiFormatListBulletedType,
  mdiHeartPulse,
  mdiHelpCircleOutline,
  mdiHistory,
  mdiHome,
  mdiImage,
  mdiImageMultiple,
  mdiImageMultipleOutline,
  mdiImagePlus,
  mdiImageRefresh,
  mdiImport,
  mdiInformation,
  mdiInformationOutline,
  mdiKey,
  mdiKeyAlert,
  mdiKeyChain,
  mdiKeyChange,
  mdiKeyPlus,
  mdiKeyRemove,
  mdiKeyVariant,
  mdiLink,
  mdiLoading,
  mdiLock,
  mdiLockCheck,
  mdiLockOpen,
  mdiLockReset,
  mdiLogin,
  mdiLogout,
  mdiLogoutVariant,
  mdiMagnify,
  mdiMap,
  mdiMapMarker,
  mdiMapMarkerCheck,
  mdiMapMarkerMultiple,
  mdiMapMarkerOff,
  mdiMapPlus,
  mdiMapSearch,
  mdiMenu,
  mdiMessageTextOutline,
  mdiMicrosoftExcel,
  mdiMinusCircle,
  mdiMonitor,
  mdiMusic,
  mdiOpenInNew,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiPalette,
  mdiPaperclip,
  mdiPause,
  mdiPencil,
  mdiPencilOff,
  mdiPhone,
  mdiPlay,
  mdiPlus,
  mdiPlusCircle,
  mdiPlusCircleMultiple,
  mdiRefresh,
  mdiRefreshCircle,
  mdiRestore,
  mdiRocketLaunchOutline,
  mdiSale,
  mdiScaleBalance,
  mdiSend,
  mdiShapeOutline,
  mdiShareVariant,
  mdiShareVariantOutline,
  mdiShieldKey,
  mdiShieldLock,
  mdiShieldOff,
  mdiShuffle,
  mdiShuffleVariant,
  mdiSigma,
  mdiSilverwareForkKnife,
  mdiSitemap,
  mdiStar,
  mdiStore,
  mdiStorefront,
  mdiSvg,
  mdiSwapHorizontal,
  mdiTable,
  mdiTableColumn,
  mdiTableEdit,
  mdiTablePlus,
  mdiTableRemove,
  mdiTableSearch,
  mdiTag,
  mdiTagEdit,
  mdiTagMultiple,
  mdiTagMultipleOutline,
  mdiTagOff,
  mdiTagOffOutline,
  mdiTagPlus,
  mdiTagRemove,
  mdiTarget,
  mdiTestTube,
  mdiTextBoxEdit,
  mdiTextSearch,
  mdiThemeLightDark,
  mdiTimelineClock,
  mdiTimerCheck,
  mdiTimerOff,
  mdiTimerRefresh,
  mdiToggleSwitch,
  mdiTruck,
  mdiTruckDelivery,
  mdiTruckOutline,
  mdiTune,
  mdiUpload,
  mdiUploadOff,
  mdiVideo,
  mdiViewDashboard,
  mdiViewGrid,
  mdiViewList,
  mdiWarehouse,
  mdiWeatherNight,
  mdiWeatherSunny,
  mdiWizardHat,
} from "@mdi/js";

const icons = {
  "mdi-account": mdiAccount,
  "mdi-account-box": mdiAccountBox,
  "mdi-account-cancel": mdiAccountCancel,
  "mdi-account-cash": mdiAccountCash,
  "mdi-account-check": mdiAccountCheck,
  "mdi-account-clock": mdiAccountClock,
  "mdi-account-cog": mdiAccountCog,
  "mdi-account-edit": mdiAccountEdit,
  "mdi-account-group": mdiAccountGroup,
  "mdi-account-multiple": mdiAccountMultiple,
  "mdi-account-off": mdiAccountOff,
  "mdi-account-plus": mdiAccountPlus,
  "mdi-account-remove": mdiAccountRemove,
  "mdi-account-tie": mdiAccountTie,
  "mdi-alert": mdiAlert,
  "mdi-alert-circle": mdiAlertCircle,
  "mdi-alert-circle-outline": mdiAlertCircleOutline,
  "mdi-alert-octagon": mdiAlertOctagon,
  "mdi-alert-outline": mdiAlertOutline,
  "mdi-api": mdiApi,
  "mdi-apps": mdiApps,
  "mdi-apps-box": mdiAppsBox,
  "mdi-archive": mdiArchive,
  "mdi-arrow-collapse-vertical": mdiArrowCollapseVertical,
  "mdi-arrow-down": mdiArrowDown,
  "mdi-arrow-expand-vertical": mdiArrowExpandVertical,
  "mdi-arrow-left": mdiArrowLeft,
  "mdi-arrow-up": mdiArrowUp,
  "mdi-bank": mdiBank,
  "mdi-book-edit-outline": mdiBookEditOutline,
  "mdi-book-open-page-variant": mdiBookOpenPageVariant,
  "mdi-book-open-variant": mdiBookOpenVariant,
  "mdi-briefcase": mdiBriefcase,
  "mdi-briefcase-check": mdiBriefcaseCheck,
  "mdi-briefcase-off": mdiBriefcaseOff,
  "mdi-briefcase-outline": mdiBriefcaseOutline,
  "mdi-briefcase-plus": mdiBriefcasePlus,
  "mdi-briefcase-remove": mdiBriefcaseRemove,
  "mdi-briefcase-search": mdiBriefcaseSearch,
  "mdi-bullhorn": mdiBullhorn,
  "mdi-bullhorn-outline": mdiBullhornOutline,
  "mdi-calculator": mdiCalculator,
  "mdi-calculator-variant": mdiCalculatorVariant,
  "mdi-calendar": mdiCalendar,
  "mdi-calendar-account": mdiCalendarAccount,
  "mdi-calendar-blank": mdiCalendarBlank,
  "mdi-calendar-blank-outline": mdiCalendarBlankOutline,
  "mdi-calendar-check": mdiCalendarCheck,
  "mdi-calendar-check-outline": mdiCalendarCheckOutline,
  "mdi-calendar-clock": mdiCalendarClock,
  "mdi-calendar-minus": mdiCalendarMinus,
  "mdi-calendar-month": mdiCalendarMonth,
  "mdi-calendar-plus": mdiCalendarPlus,
  "mdi-calendar-range": mdiCalendarRange,
  "mdi-calendar-remove": mdiCalendarRemove,
  "mdi-calendar-today": mdiCalendarToday,
  "mdi-calendar-week": mdiCalendarWeek,
  "mdi-camera": mdiCamera,
  "mdi-cancel": mdiCancel,
  "mdi-cash": mdiCash,
  "mdi-cash-multiple": mdiCashMultiple,
  "mdi-cash-register": mdiCashRegister,
  "mdi-cellphone-key": mdiCellphoneKey,
  "mdi-chart-areaspline": mdiChartAreaspline,
  "mdi-chart-bar": mdiChartBar,
  "mdi-chart-box-multiple-outline": mdiChartBoxMultipleOutline,
  "mdi-chart-box-outline": mdiChartBoxOutline,
  "mdi-chart-line": mdiChartLine,
  "mdi-chart-line-variant": mdiChartLineVariant,
  "mdi-chart-timeline": mdiChartTimeline,
  "mdi-check": mdiCheck,
  "mdi-check-all": mdiCheckAll,
  "mdi-check-circle": mdiCheckCircle,
  "mdi-check-circle-outline": mdiCheckCircleOutline,
  "mdi-checkbox-multiple-blank-outline": mdiCheckboxMultipleBlankOutline,
  "mdi-checkbox-multiple-marked": mdiCheckboxMultipleMarked,
  "mdi-chevron-down": mdiChevronDown,
  "mdi-chevron-left": mdiChevronLeft,
  "mdi-chevron-right": mdiChevronRight,
  "mdi-chevron-up": mdiChevronUp,
  "mdi-circle": mdiCircle,
  "mdi-circle-half-full": mdiCircleHalfFull,
  "mdi-circle-outline": mdiCircleOutline,
  "mdi-city": mdiCity,
  "mdi-city-variant": mdiCityVariant,
  "mdi-clipboard-alert-outline": mdiClipboardAlertOutline,
  "mdi-clipboard-check-outline": mdiClipboardCheckOutline,
  "mdi-clipboard-list": mdiClipboardList,
  "mdi-clipboard-text-outline": mdiClipboardTextOutline,
  "mdi-clock-outline": mdiClockOutline,
  "mdi-close": mdiClose,
  "mdi-close-circle": mdiCloseCircle,
  "mdi-cloud-download": mdiCloudDownload,
  "mdi-cloud-outline": mdiCloudOutline,
  "mdi-code-braces": mdiCodeBraces,
  "mdi-cog": mdiCog,
  "mdi-cog-off": mdiCogOff,
  "mdi-cog-outline": mdiCogOutline,
  "mdi-comment-edit": mdiCommentEdit,
  "mdi-comment-plus": mdiCommentPlus,
  "mdi-comment-remove": mdiCommentRemove,
  "mdi-comment-text-multiple": mdiCommentTextMultiple,
  "mdi-console": mdiConsole,
  "mdi-content-copy": mdiContentCopy,
  "mdi-content-duplicate": mdiContentDuplicate,
  "mdi-content-save": mdiContentSave,
  "mdi-counter": mdiCounter,
  "mdi-currency-usd": mdiCurrencyUsd,
  "mdi-database": mdiDatabase,
  "mdi-database-edit-outline": mdiDatabaseEditOutline,
  "mdi-database-import": mdiDatabaseImport,
  "mdi-database-plus": mdiDatabasePlus,
  "mdi-database-remove": mdiDatabaseRemove,
  "mdi-delete": mdiDelete,
  "mdi-delete-alert": mdiDeleteAlert,
  "mdi-delete-sweep": mdiDeleteSweep,
  "mdi-dots-vertical": mdiDotsVertical,
  "mdi-download": mdiDownload,
  "mdi-download-off": mdiDownloadOff,
  "mdi-download-outline": mdiDownloadOutline,
  "mdi-earth": mdiEarth,
  "mdi-earth-off": mdiEarthOff,
  "mdi-email-check": mdiEmailCheck,
  "mdi-email-fast": mdiEmailFast,
  "mdi-email-lock": mdiEmailLock,
  "mdi-email-outline": mdiEmailOutline,
  "mdi-email-sync": mdiEmailSync,
  "mdi-equal": mdiEqual,
  "mdi-export": mdiExport,
  "mdi-eye": mdiEye,
  "mdi-eye-check": mdiEyeCheck,
  "mdi-eye-off": mdiEyeOff,
  "mdi-file": mdiFile,
  "mdi-file-delimited": mdiFileDelimited,
  "mdi-file-delimited-outline": mdiFileDelimitedOutline,
  "mdi-file-document": mdiFileDocument,
  "mdi-file-document-multiple": mdiFileDocumentMultiple,
  "mdi-file-document-outline": mdiFileDocumentOutline,
  "mdi-file-excel": mdiFileExcel,
  "mdi-file-excel-box": mdiFileExcelBox,
  "mdi-file-excel-outline": mdiFileExcelOutline,
  "mdi-file-import-outline": mdiFileImportOutline,
  "mdi-file-pdf-box": mdiFilePdfBox,
  "mdi-file-tree": mdiFileTree,
  "mdi-file-upload": mdiFileUpload,
  "mdi-file-word": mdiFileWord,
  "mdi-filter": mdiFilter,
  "mdi-filter-off": mdiFilterOff,
  "mdi-filter-remove": mdiFilterRemove,
  "mdi-filter-variant": mdiFilterVariant,
  "mdi-flag": mdiFlag,
  "mdi-folder-image": mdiFolderImage,
  "mdi-folder-multiple": mdiFolderMultiple,
  "mdi-folder-multiple-image": mdiFolderMultipleImage,
  "mdi-folder-open-outline": mdiFolderOpenOutline,
  "mdi-folder-zip": mdiFolderZip,
  "mdi-food-apple": mdiFoodApple,
  "mdi-food-variant": mdiFoodVariant,
  "mdi-form-select": mdiFormSelect,
  "mdi-git": mdiGit,
  "mdi-format-list-bulleted": mdiFormatListBulleted,
  "mdi-format-list-bulleted-type": mdiFormatListBulletedType,
  "mdi-heart-pulse": mdiHeartPulse,
  "mdi-help-circle-outline": mdiHelpCircleOutline,
  "mdi-history": mdiHistory,
  "mdi-home": mdiHome,
  "mdi-image": mdiImage,
  "mdi-image-multiple": mdiImageMultiple,
  "mdi-image-multiple-outline": mdiImageMultipleOutline,
  "mdi-image-plus": mdiImagePlus,
  "mdi-image-refresh": mdiImageRefresh,
  "mdi-import": mdiImport,
  "mdi-information": mdiInformation,
  "mdi-information-outline": mdiInformationOutline,
  "mdi-key": mdiKey,
  "mdi-key-alert": mdiKeyAlert,
  "mdi-key-chain": mdiKeyChain,
  "mdi-key-change": mdiKeyChange,
  "mdi-key-plus": mdiKeyPlus,
  "mdi-key-remove": mdiKeyRemove,
  "mdi-key-variant": mdiKeyVariant,
  "mdi-link": mdiLink,
  "mdi-loading": mdiLoading,
  "mdi-lock": mdiLock,
  "mdi-lock-check": mdiLockCheck,
  "mdi-lock-open": mdiLockOpen,
  "mdi-lock-reset": mdiLockReset,
  "mdi-login": mdiLogin,
  "mdi-logout": mdiLogout,
  "mdi-logout-variant": mdiLogoutVariant,
  "mdi-magnify": mdiMagnify,
  "mdi-map": mdiMap,
  "mdi-map-marker": mdiMapMarker,
  "mdi-map-marker-check": mdiMapMarkerCheck,
  "mdi-map-marker-multiple": mdiMapMarkerMultiple,
  "mdi-map-marker-off": mdiMapMarkerOff,
  "mdi-map-plus": mdiMapPlus,
  "mdi-map-search": mdiMapSearch,
  "mdi-menu": mdiMenu,
  "mdi-message-text-outline": mdiMessageTextOutline,
  "mdi-microsoft-excel": mdiMicrosoftExcel,
  "mdi-minus-circle": mdiMinusCircle,
  "mdi-monitor": mdiMonitor,
  "mdi-music": mdiMusic,
  "mdi-open-in-new": mdiOpenInNew,
  "mdi-package-variant": mdiPackageVariant,
  "mdi-package-variant-closed": mdiPackageVariantClosed,
  "mdi-palette": mdiPalette,
  "mdi-paperclip": mdiPaperclip,
  "mdi-pause": mdiPause,
  "mdi-pencil": mdiPencil,
  "mdi-pencil-off": mdiPencilOff,
  "mdi-phone": mdiPhone,
  "mdi-play": mdiPlay,
  "mdi-plus": mdiPlus,
  "mdi-plus-circle": mdiPlusCircle,
  "mdi-plus-circle-multiple": mdiPlusCircleMultiple,
  "mdi-refresh": mdiRefresh,
  "mdi-refresh-circle": mdiRefreshCircle,
  "mdi-restore": mdiRestore,
  "mdi-rocket-launch-outline": mdiRocketLaunchOutline,
  "mdi-sale": mdiSale,
  "mdi-scale-balance": mdiScaleBalance,
  "mdi-send": mdiSend,
  "mdi-shape-outline": mdiShapeOutline,
  "mdi-share-variant": mdiShareVariant,
  "mdi-share-variant-outline": mdiShareVariantOutline,
  "mdi-shield-key": mdiShieldKey,
  "mdi-shield-lock": mdiShieldLock,
  "mdi-shield-off": mdiShieldOff,
  "mdi-shuffle": mdiShuffle,
  "mdi-shuffle-variant": mdiShuffleVariant,
  "mdi-sigma": mdiSigma,
  "mdi-silverware-fork-knife": mdiSilverwareForkKnife,
  "mdi-sitemap": mdiSitemap,
  "mdi-star": mdiStar,
  "mdi-store": mdiStore,
  "mdi-storefront": mdiStorefront,
  "mdi-svg": mdiSvg,
  "mdi-swap-horizontal": mdiSwapHorizontal,
  "mdi-table": mdiTable,
  "mdi-table-column": mdiTableColumn,
  "mdi-table-edit": mdiTableEdit,
  "mdi-table-plus": mdiTablePlus,
  "mdi-table-remove": mdiTableRemove,
  "mdi-table-search": mdiTableSearch,
  "mdi-tag": mdiTag,
  "mdi-tag-edit": mdiTagEdit,
  "mdi-tag-multiple": mdiTagMultiple,
  "mdi-tag-multiple-outline": mdiTagMultipleOutline,
  "mdi-tag-off": mdiTagOff,
  "mdi-tag-off-outline": mdiTagOffOutline,
  "mdi-tag-plus": mdiTagPlus,
  "mdi-tag-remove": mdiTagRemove,
  "mdi-target": mdiTarget,
  "mdi-test-tube": mdiTestTube,
  "mdi-text-box-edit": mdiTextBoxEdit,
  "mdi-text-search": mdiTextSearch,
  "mdi-theme-light-dark": mdiThemeLightDark,
  "mdi-timeline-clock": mdiTimelineClock,
  "mdi-timer-check": mdiTimerCheck,
  "mdi-timer-off": mdiTimerOff,
  "mdi-timer-refresh": mdiTimerRefresh,
  "mdi-toggle-switch": mdiToggleSwitch,
  "mdi-truck": mdiTruck,
  "mdi-truck-delivery": mdiTruckDelivery,
  "mdi-truck-outline": mdiTruckOutline,
  "mdi-tune": mdiTune,
  "mdi-upload": mdiUpload,
  "mdi-upload-off": mdiUploadOff,
  "mdi-video": mdiVideo,
  "mdi-view-dashboard": mdiViewDashboard,
  "mdi-view-grid": mdiViewGrid,
  "mdi-view-list": mdiViewList,
  "mdi-warehouse": mdiWarehouse,
  "mdi-weather-night": mdiWeatherNight,
  "mdi-weather-sunny": mdiWeatherSunny,
  "mdi-wizard-hat": mdiWizardHat,
};

const mdiSvgComponent = defineComponent({
  name: "MdiSvgResolver",
  props: { icon: { required: true }, tag: { default: "i" } },
  setup(props, { attrs }) {
    return () => {
      const resolved = icons[props.icon] || (typeof props.icon === "string" && /^[Mm]/.test(props.icon) ? props.icon : null);
      if (!resolved) {
        if (import.meta.env.DEV) {
          console.warn(`[mdiIcons] Unknown icon: "${props.icon}" — add it to scripts/generateMdiIcons.js and re-run`);
        }
        return null;
      }
      return h(VSvgIcon, { ...attrs, icon: resolved, tag: props.tag });
    };
  },
});

export const mdiSvgSet = {
  component: mdiSvgComponent,
};
